import Script from 'next/script';

const NextdoorPixel = () => (
  <>
    <Script id="NextdoorPixel">
      {`
      !function(e,n){var t,p;e.ndp||((t=e.ndp=function(){
      t.handleRequest?t.handleRequest.apply(t,arguments):t.queue.push(arguments)
      }).queue=[],t.v=1,(p=n.createElement(e="script")).async=!0,
      p.src="https://ads.nextdoor.com/public/pixel/ndp.js?id=ccd4765a-e08d-4674-84ab-9e025125ac78",
      (n=n.getElementsByTagName(e)[0]).parentNode.insertBefore(p,n))
      }(window,document);

      ndp('init','ccd4765a-e08d-4674-84ab-9e025125ac78', {});
      ndp('track','PAGE_VIEW');
    `}
    </Script>
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src="https://flask.nextdoor.com/pixel?pid=ccd4765a-e08d-4674-84ab-9e025125ac78&ev=PAGE_VIEW&noscript=1"
      />
    </noscript>
  </>
);

export default NextdoorPixel;
